import React from "react";

const TalksPreview = ({ phrase }) => {
  return (
    <>{phrase && phrase.map((phrase, index) => <p key={index}>{phrase}</p>)}</>
  );
};

export default TalksPreview;
